import styled from 'styled-components';

export const StyledDropzone = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 28px;
`;
